import React, { useCallback, useContext, useEffect, useState } from "react";

import {
  Breadcrumb,
  IBreadcrumbItem,
  IColumn,
  ICommandBarItemProps,
  Icon,
  SearchBox,
  SelectionMode,
  Spinner,
  SpinnerSize,
  TooltipHost,
  mergeStyleSets,
} from "@fluentui/react";
import IconHelper from "../../../utils/helpers/iconHelper";
import { HeaderGestionDocumentos } from "../general/HeaderGestionDocumentos";
import COLORES from "../../../utils/theme/colores";
import themeBase from "../../../utils/theme/themeBase";
import { useLocation, useNavigate } from "react-router-dom";

import { TableV8 } from "../../../components/Table/TablaV8";
import { PaginationV8 } from "../../../components/PaginationFooter/PaginationV8";
import { IItemLink, useDocumentos } from "../hooks/useDocumentos";
import { PanelRegistrarSubGrupo } from "./PanelRegistrarSubGrupo";
import { useBoolean } from "@fluentui/react-hooks";
import { ITablaGruposDocumentos } from "../../../Interfaces/gestionDocumentos/IGrupoDocumento";
import { PanelRegistrarDocumento } from "./PanelRegistrarDocumento";
import { PanelViewPdfDocumento } from "./PanelViewPdfDocumento";
import { DownloadFiles } from "../general/DownloadFile";
import { PanelEliminarArchivo } from "./PanelEliminarArchivo";
import { PanelEditarDocumento } from "./PanelEditarDocumento";
import { PanelEditarSubGrupo } from "./PanelEditarSubgrupo";
import { PanelHistorialArchivo } from "./PanelHistorialArchivo";
import { Selection } from "@fluentui/react";
import { PanelEliminarDocumentos } from "./PanelEliminarDocumentos";
import grupoDocumentoService from "../../../services/gestionDocumentos/grupoDocumentoService";
import axios from "axios";
import { text } from "d3";
import { AuthContext } from "../../../auth/context/auth-context";
import { Authorize } from "../../../utils/helpers/authorize";
import { ROLE_ADMIN, R_GESTION_DOC } from "../../../utils/helpers/roleHelpers";

export interface IParent {
  archivoId: string;
  grupo: string;
}

const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: "16px",
  },
  fileIconCell: {
    textAlign: "center",
    selectors: {
      "&:before": {
        content: ".",
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0px",
        visibility: "hidden",
      },
    },
  },
  fileIconImg: {
    verticalAlign: "middle",
    maxHeight: "20px",
    maxWidth: "20px",
  },
  controlWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  exampleToggle: {
    display: "inline-block",
    marginBottom: "10px",
    marginRight: "30px",
  },
  selectionDetails: {
    marginBottom: "20px",
  },
});

export const VistaGestionDocumentos = () => {
  const navigate = useNavigate();

  const { access } = useContext(AuthContext);

  const userRoles = access?.role || [];

  let esEscrituraDoc = Authorize(userRoles, [
    R_GESTION_DOC,
    ROLE_ADMIN,
  ]);

  const { state } = useLocation();
  const dataLocation: any = state;
  var archivoId =
    dataLocation != undefined &&
      dataLocation != null &&
      dataLocation.hasOwnProperty("archivoId")
      ? dataLocation.archivoId
      : "";
  var grupo =
    dataLocation != undefined &&
      dataLocation != null &&
      dataLocation.hasOwnProperty("grupo")
      ? dataLocation.grupo
      : "";

  const getStorageUseState = (): IParent | undefined => {
    let arrayString = localStorage.getItem("miArray");
    if (arrayString != null && arrayString != undefined) {
      let arrayObtenido: any[] = arrayString
        ? JSON.parse(arrayString!.replace(/\\/g, ""))
        : [];

      var aux: IItemLink[] = arrayObtenido.map((h) => ({
        key: h.key,
        text: h.text,
        active: h.active,
      }));

      if (aux.length > 0) {
        let objeto: IParent = {
          archivoId: aux[aux.length - 1].key,
          grupo: aux[aux.length - 1].text,
        };

        return objeto;
      } else {
        let objeto: IParent = { archivoId: "", grupo: "" };
        return objeto;
      }
    }
  };

  const [parent, setparent] = useState<IParent>(getStorageUseState()!);
  const [itemslink, setItemsLink] = useState<IBreadcrumbItem[]>([]);

  const {
    loading,
    items,
    filter,
    setFilter,
    limpiarFiltro,
    postListaTabla,
    paginacionTable,
    total,
    nivel,
    onChangeTextSearch,
  } = useDocumentos();

  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  const [
    isOpenEditarDocumento,
    {
      setTrue: openPanelEditarDocumento,
      setFalse: dismissPanelEditarDocumento,
    },
  ] = useBoolean(false);
  const [
    isOpenEditarSubgrupo,
    { setTrue: openPanelEditarSubGrupo, setFalse: dismissPanelEditarSubgrupo },
  ] = useBoolean(false);

  const [
    isOpenDocumento,
    { setTrue: openPanelDocumento, setFalse: dismissPanelDocumento },
  ] = useBoolean(false);

  const [
    isOpenDelete,
    { setTrue: openPanelDelete, setFalse: dismissPanelDelete },
  ] = useBoolean(false);
  const [
    isOpenDeleteDocumentos,
    {
      setTrue: openPanelDeleteDocumentos,
      setFalse: dismissPanelDeleteDocumentos,
    },
  ] = useBoolean(false);

  const [
    isOpenVisualizarDoc,
    { setTrue: openPanelVisualizarDoc, setFalse: dismissPanelVisualizarDoc },
  ] = useBoolean(false);

  const [
    isOpenHistorial,
    { setTrue: openPanelHistorial, setFalse: dismissPanelHistorial },
  ] = useBoolean(false);

  const [urlDoc, seturlDoc] = useState("");
  const [isFolder, setisFolder] = useState(false);
  const [nombre, setnombre] = useState("");
  const [id, setid] = useState("");

  const [selectedItems, setSelectedItems] = useState<ITablaGruposDocumentos[]>(
    []
  );

  const [loadingDownload, setLoadingDownload] = useState<boolean>(false);

  const _itemBack: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_BACK2,
      onClick: () => {
        window.history.back();
      },
    },
  ];

  const crearStorage = (parent: IParent) => {
    const arrayString = localStorage.getItem("miArray");
    //  window.alert(arrayString);
    if (arrayString == null) {
      setparent({ grupo: grupo, archivoId: archivoId });

      localStorage.setItem(
        "miArray",
        JSON.stringify([
          { key: parent.archivoId, text: parent.grupo, active: true },
        ])
      );
    }
  };

  const pasarArrayFalse = (arr: any[]): IItemLink[] => {
    var historyAux: IItemLink[] = arr.map((h) => ({
      ...h,
      active: false,
    }));
    return historyAux;
  };

  const isExist = (key: string, arr: any[]) => {
    var array = arr.find((x) => x.key.toLowerCase() === key.toLowerCase());

    if (array != null && array != undefined) {
      return true;
    } else {
      return false;
    }
  };

  const addStorage = (parent: IParent) => {
    let arrayString = localStorage.getItem("miArray");
    if (arrayString) {
      let arrayObtenido = arrayString
        ? JSON.parse(arrayString!.replace(/\\/g, ""))
        : [];

      if (!isExist(parent.archivoId, arrayObtenido)) {
        setparent(parent);
        let arrayObtenido = arrayString ? JSON.parse(arrayString) : [];
        let array: IItemLink[] = pasarArrayFalse(arrayObtenido);
        array = [
          ...array,
          { key: parent.archivoId, text: parent.grupo, active: true },
        ];

        localStorage.setItem("miArray", JSON.stringify(array));
      }
    }
  };

  const getStorage = (): IItemLink[] => {
    let arrayString = localStorage.getItem("miArray");
    if (arrayString) {
      let arrayObtenido: any[] = arrayString
        ? JSON.parse(arrayString!.replace(/\\/g, ""))
        : [];

      var aux: IItemLink[] = arrayObtenido.map((h) => ({
        key: h.key,
        text: h.text,
        active: h.active,
      }));

      return aux;
    }
    return [];
  };

  useEffect(() => {
    if (archivoId != "" && grupo != "") {
      crearStorage({ archivoId: archivoId, grupo: grupo });
      grupo = "";
      archivoId = "";
    }
  }, []);

  useEffect(() => {
    if (
      parent != undefined &&
      parent != null &&
      parent.archivoId != "" &&
      parent.grupo != ""
    ) {
      setFilter({ ...filter, parentId: parent.archivoId });
      setSelectedItems([]);
      setItemsLink(_itemslink(getStorage()));
    }
  }, [parent]);

  const _itemsLeftBar = useCallback(() => {
    let addReload: ICommandBarItemProps = {
      ...IconHelper.ICON_RELOAD2,
      key: "reloadGD",
      onClick: () => {
        if (parent) {
          limpiarFiltro(parent.archivoId!);
        }
      },
    };

    // Condicionalmente crea addSubGroup y addDocument basados en esEscrituraDoc
    let addSubGroup: ICommandBarItemProps | null = esEscrituraDoc
      ? {
        ...IconHelper.ICON_ADD_TABLE,
        key: "addSGGD",
        text: "Agregar Subgrupo",
        onClick: () => openPanel(),
      }
      : null;

    let addDocument: ICommandBarItemProps | null = esEscrituraDoc
      ? {
        ...IconHelper.ICON_ADD_TABLE,
        key: "addDGD",
        text: "Subir Documento",
        onClick: () => openPanelDocumento(),
      }
      : null;

    let addDownloadFiles: ICommandBarItemProps = {
      ...IconHelper.ICON_DOWNLOAD,
      key: "addDownloadGD",
      text: "Descargar Documentos",
      disabled: loadingDownload ? true : false,
      ...(loadingDownload
        ? {
          onRenderIcon() {
            return <>{<Spinner size={SpinnerSize.xSmall} />}</>;
          },
        }
        : {}),
      onClick: () => postDownloadZip(),
    };

    // Condicionalmente crea addDeleteFiles basado en esEscrituraDoc
    let addDeleteFiles: ICommandBarItemProps | null = esEscrituraDoc
      ? {
        ...IconHelper.ICON_DELETE,
        key: "addDeleteGD",
        text: "Eliminar Documentos",
        onClick: () => openPanelDeleteDocumentos(),
      }
      : null;

    var array: ICommandBarItemProps[] = [addReload];

    if (esEscrituraDoc) {
      if (nivel != 0 && nivel <= 2 && addSubGroup) {
        array.unshift(addSubGroup);
      } else {
        if (addDocument) {
          array.unshift(addDocument);
        }
        if (addSubGroup) {
          array.unshift(addSubGroup);
        }
      }

      if (selectedItems.length > 0) {
        if (
          !array.find((a) => a.key === addDownloadFiles.key) &&
          addDeleteFiles &&
          !array.find((a) => a.key === addDeleteFiles?.key)
        ) {
          array.unshift(addDeleteFiles);
          array.unshift(addDownloadFiles);
        }
      } else if (selectedItems.length === 0) {
        array = array.filter((a) => a.key !== addDownloadFiles.key);
        if (addDeleteFiles) {
          array = array.filter((a) => a.key !== addDeleteFiles?.key);
        }
      }
    } else {
      if (selectedItems.length > 0) {
        if (!array.find((a) => a.key === addDownloadFiles.key)) {
          array.unshift(addDownloadFiles);
        }
      } else {
        array = array.filter((a) => a.key !== addDownloadFiles.key);
      }
    }

    return array;
  }, [filter, parent, nivel, selectedItems, loadingDownload, esEscrituraDoc]);


  const _itemRigthBar: ICommandBarItemProps[] = [
    {
      key: "Search",
      onRender: (item) => {
        return (
          <div>
            <SearchBox
              key={"searchBoxGestDoc"}
              // underlined
              // componentRef={undefined}
              placeholder={"Buscar"}
              // onKeyUp={undefined}
              onChange={onChangeTextSearch}
              value={filter.search}
              styles={{
                root: {
                  borderColor: "#bababa",
                  width: "300px",
                  height: "28px",
                  fontSize: 12,
                  borderRadius: "2px",
                },
              }}
            />
          </div>
        );
      },
    },
  ];
  const _columns: IColumn[] = [
    {
      key: "nombre",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
      //   isSorted: true,
      //   isSortedDescending: true,
      onRender: (item: ITablaGruposDocumentos) => (
        <>
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "5px" }}
          >
            {item.isFolder ? (
              <>
                {/* <FontIcon
                  aria-label="Compass"
                  iconName="FolderList"
                  style={{ fontSize: 15, color: "rgb(245, 184, 0)" }}
                  // className={undefined}
                /> */}
                <img
                  src={
                    "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/item-types/16/folder.svg"
                  }
                  className={classNames.fileIconImg}
                  alt={` folder icon`}
                />
              </>
            ) : (
              <>
                <img
                  src={
                    "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/item-types/16/pdf.svg"
                  }
                  className={classNames.fileIconImg}
                  alt={` folder icon`}
                />
              </>
            )}

            {item.nombre}
          </div>
        </>
      ),
    },

    {
      key: "nombreArchivo",
      name: "Nombre Archivo",
      fieldName: "nombreArchivo",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "size",
      name: "Tamaño de archivo",
      fieldName: "size",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },

    {
      key: "fecha",
      name: "Fecha de Creación",
      fieldName: "fecha",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "usuario",
      name: "Registrado Por",
      fieldName: "usuario",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "",
      minWidth: 120,
      maxWidth: 120,
      isResizable: true,
      onRender: (item: ITablaGruposDocumentos) => (
        <>
          <div style={{ display: "flex", columnGap: "5px" }}>
            {esEscrituraDoc && (<>
              <TooltipHost content="Actualizar">
                <Icon
                  iconName="edit"
                  style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                  className={themeBase.classNamesIcon.iconFont}
                  onClick={() => {
                    setnombre(item.nombre);
                    setid(item.archivoId);
                    if (item.isFolder) {
                      openPanelEditarSubGrupo();
                    } else {
                      openPanelEditarDocumento();
                    }
                  }}
                />
              </TooltipHost>
            </>)}

            {!item.isFolder && (
              <TooltipHost content="Visualizar">
                <Icon
                  // iconName="Page"
                  iconName="PDF"
                  // style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                  style={{ cursor: "pointer", color: "red" }}
                  className={themeBase.classNamesIcon.iconFont}
                  onClick={() => {
                    seturlDoc(item.urlDocumento!);
                    openPanelVisualizarDoc();
                  }}
                />
              </TooltipHost>
            )}
            {!item.isFolder && (
              // <TooltipHost content="Descargar">
              //   {loadPdf ? (
              //     <Spinner size={SpinnerSize.xSmall} />
              //   ) : (
              //     <Icon
              //       iconName="Download"
              //       style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
              //       className={themeBase.classNamesIcon.iconFont}
              //       onClick={() => {
              //         dataApiBlobs(item.urlDocumento!, item.nombreArchivo!);
              //       }}
              //     />
              //   )}
              // </TooltipHost>
              <DownloadFiles url={item.urlDocumento!} nombre={item.nombre} />
            )}
            {esEscrituraDoc && (
              <>
                <TooltipHost content="Eliminar">
                  <Icon
                    iconName="delete"
                    style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                    className={themeBase.classNamesIcon.iconFont}
                    onClick={() => {
                      if (item.isFolder) {
                        setisFolder(true);
                        setid(item.archivoId);
                      } else {
                        setisFolder(false);
                        setid(item.archivoId);
                      }
                      openPanelDelete();
                    }}
                  />
                </TooltipHost>
              </>
            )}

            {item.isFolder && (
              <TooltipHost content="Gestión de Grupos">
                <Icon
                  iconName="FolderSearch"
                  style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                  className={themeBase.classNamesIcon.iconFont}
                  onClick={() => {
                    // navigate(
                    //   `${ConfigHelper.urlBase()}/DetallePersona/${
                    //     item?.personaId
                    //   }`
                    // );
                    addStorage({
                      archivoId: item.archivoId,
                      grupo: item.nombre,
                    });
                  }}
                />
              </TooltipHost>
            )}

            {!item.isFolder && (
              <TooltipHost content="Historial">
                <Icon
                  iconName="Clock"
                  style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                  className={themeBase.classNamesIcon.iconFont}
                  onClick={() => {
                    setid(item.archivoId);
                    openPanelHistorial();
                  }}
                />
              </TooltipHost>
            )}
          </div>
        </>
      ),
    },
  ];

  const _itemslink = (arr: any[]): IBreadcrumbItem[] =>
    arr.map((h) => {
      var data: IBreadcrumbItem = {
        ...h,
        onClick: _onBreadcrumbItemClicked,
        style: { color: "rgb(0, 120, 212)" },
      };
      return data;
    });

  function _onBreadcrumbItemClicked(ev: any, item: any): void {
    let arrayString = localStorage.getItem("miArray");
    if (arrayString) {
      let arrayObtenido: any[] = arrayString
        ? JSON.parse(arrayString!.replace(/\\/g, ""))
        : [];

      var aux: IItemLink[] = arrayObtenido.map((h) => ({
        key: h.key,
        text: h.text,
        active: h.active,
      }));

      let array: IItemLink[] = pasarArrayFalse(aux);
      const indice = array.findIndex(
        (objeto) => objeto.key.toLowerCase() === item.key.toLowerCase()
      );
      if (indice !== -1) {
        array = array.slice(0, indice + 1);
        if (array.length > 0) {
          const indiceArray = array.findIndex(
            (objeto) => objeto.key.toLowerCase() === item.key.toLowerCase()
          );
          array[indiceArray].active = true;
          //Convertir objeto a tipo IBreadcrumbItem

          var newArrayLista = array.map((h) => {
            var data: IBreadcrumbItem = {
              ...h,
              onClick: _onBreadcrumbItemClicked,
            };
            return data;
            // key:"dd",te,onClick: _onBreadcrumbItemClicked}:IBreadcrumbItem
          });

          if (newArrayLista.length > 0) {
            let objeto: IParent = {
              archivoId: newArrayLista[newArrayLista.length - 1].key,
              grupo: newArrayLista[newArrayLista.length - 1].text,
            };
            //seteo de nueva lista

            setparent(() => objeto);
            localStorage.setItem("miArray", JSON.stringify(newArrayLista));
          }
        }
      }
    }
  }

  const selection = new Selection({
    onSelectionChanged: () => {
      let aux: any[] = selection.getSelection();
      console.log(aux);
      setSelectedItems(aux);
    },
    canSelectItem: (item, i) => {
      let archivo: any = item;
      return archivo.isFolder ? false : true;
    },
  });

  const postDownloadZip = () => {
    setLoadingDownload(true);
    grupoDocumentoService
      .postDownloadZip(selectedItems.map((i) => i.archivoId))
      .then((res) => {
        if (res.status == 200) {
          decodeBase64ToPdf(res.data);
        }
      })

      .catch((e) => {
        if (axios.isCancel(e)) {
        } else {
          console.error("Error en la solicitud:", e?.message);
          // setLoading(false);
        }
      });
  };

  function decodeBase64ToPdf(encodedString) {
    fetch(encodedString)
      .then((res) => res.blob())
      .then((blob) => {
        // console.log("blob", blob);
        const url = window.URL.createObjectURL(blob);
        console.log(url);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Documentos ${formatDate()}.zip`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        setLoadingDownload(false);
      });
  }

  const formatDate = () => {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <>
      {/* <pre>{JSON.stringify("--------Exist Data userRoles---", null, 2)}</pre>
      <pre>{JSON.stringify(userRoles, null, 2)}</pre>
      <pre>{JSON.stringify(esEscrituraDoc, null, 2)}</pre> */}
      <div>
        <HeaderGestionDocumentos
          items={_itemBack}
          title="Gestión de Documentos"
          subTitle={""}
          // subTitle={grupo}
          key={"Gestión de Documentos"}
          estiloAux={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 8px 2px 0px",
          }}
        />

        {/* <pre>{JSON.stringify(selectedItems, null, 2)}</pre> */}
        {/* <pre>{JSON.stringify(paginacionTable, null, 2)}</pre> */}
        {/* <pre>{JSON.stringify(parent, null, 2)}</pre>
         */}
        {/* <pre>{JSON.stringify(filter, null, 2)}</pre>
        <pre>{JSON.stringify(nivel, null, 2)}</pre> */}
        <div>
          <div style={{ marginLeft: "8px" }}>
            <Breadcrumb
              key="keyBreadcrud"
              items={itemslink}
              maxDisplayedItems={5}
              styles={{
                itemLink: { fontSize: "14px", color: "rgb(0, 120, 212)" },
                listItem: { color: "gold" },
                chevron: { color: "rgb(0, 120, 212)" },
                overflow: { color: "rgb(0, 120, 212)" },
                overflowButton: { color: "rgb(0, 120, 212)" },
                root: { marginTop: "0px" },
              }}
              ariaLabel="Breadcrumb with items rendered as buttons"
              overflowAriaLabel="More links"
            />
          </div>

          <TableV8
            key={"Tablev8"}
            leftBar={_itemsLeftBar()}
            rigthBar={_itemRigthBar}
            data={items}
            column={_columns}
            isLoading={loading}
            selection={selection}
            selectionMode={
              nivel != 0 && nivel <= 2
                ? SelectionMode.none
                : SelectionMode.multiple
            }
            footerPagination={
              <PaginationV8
                onChangeTake={paginacionTable.onChangeTake}
                onChangeSkip={paginacionTable.onChangeSkip}
                totalPagesPagination={paginacionTable.totalPagesPagination}
                skipPagination={paginacionTable.skipPagination}
                takePagination={paginacionTable.takePagination}
                isLoading={loading}
                cantidad={items?.length}
                total={paginacionTable.total}
              />
            }
          />
        </div>
      </div>

      <PanelRegistrarSubGrupo
        key="prg"
        isOpen={isOpen}
        onDismiss={dismissPanel}
        onRenderTable={() => limpiarFiltro(parent.archivoId)}
        parentId={parent?.archivoId}
      />

      <PanelEditarDocumento
        key="ped"
        isOpen={isOpenEditarDocumento}
        onDismiss={dismissPanelEditarDocumento}
        onRenderTable={() => limpiarFiltro(parent.archivoId)}
        archivoId={id}
        nombre={nombre}
      />

      <PanelEditarSubGrupo
        key="pes"
        isOpen={isOpenEditarSubgrupo}
        onDismiss={dismissPanelEditarSubgrupo}
        onRenderTable={() => limpiarFiltro(parent.archivoId)}
        archivoId={id}
        nombre={nombre}
        tipo="02"
      />

      <PanelRegistrarDocumento
        key="prd"
        isOpen={isOpenDocumento}
        onDismiss={dismissPanelDocumento}
        onRenderTable={() => limpiarFiltro(parent.archivoId)}
        parentId={parent?.archivoId}
      />

      <PanelViewPdfDocumento
        key="pvd"
        isOpen={isOpenVisualizarDoc}
        onDismiss={dismissPanelVisualizarDoc}
        onRenderTable={() => limpiarFiltro(parent.archivoId)}
        urlDoc={urlDoc}
      />

      <PanelEliminarArchivo
        key="pea"
        isOpen={isOpenDelete}
        onDismiss={dismissPanelDelete}
        onRenderTable={() => limpiarFiltro(parent.archivoId)}
        isFolder={isFolder}
        archivoId={id}
      />
      <PanelHistorialArchivo
        key="pha"
        isOpen={isOpenHistorial}
        onDismiss={dismissPanelHistorial}
        onRenderTable={() => limpiarFiltro(parent.archivoId)}
        archivoId={id}
      />

      <PanelEliminarDocumentos
        key="peds"
        isOpen={isOpenDeleteDocumentos}
        onDismiss={dismissPanelDeleteDocumentos}
        onRenderTable={() => limpiarFiltro(parent.archivoId)}
        setSelectedItems={setSelectedItems}
        selectedItems={selectedItems}
        // archivosId={selectedItems.map((i) => i.archivoId)}
        archivosId={selectedItems}
      />
    </>
  );
};
